import React, { useCallback, useEffect, useState } from "react";
import Header from "../Components/Header";
import Filter from "../Components/Filter";
import { formatFileSize, logAccess } from "../utils/utils";
import { useAuth } from "../../../features/auth/AuthContext";
import { fileIcons } from "../Icons";
import DataTable, { RowActionsTray } from "../Components/DataTable";
import { format } from "date-fns";
import { getFileActions } from "../utils/fileActions";
import RenameModal from "../FileActions/RenameModal";
import DeleteModal from "../FileActions/DeleteModal";
import Loader from "../Components/Loader";
import GridView from "../Components/GridView";
import FilePreviewModal2 from "../../FilePreview/FilePreviewModal2";
import MoveFile from "../FileActions/MoveFile";
import Pagination from "../Components/Pagination";
import { useFileActions } from "../hooks/useFileActions";
import { useModal } from "../hooks/useModal";
import { useRepoQuery } from "../hooks/useRepoQuery";
import FloatingAIButton from "../../FloatingAIButton/FloatingAIButton";
import {
  setDrawerState,
  setIsWebAllowed,
  setQueryMetaData,
} from "../../../state/reducers/chatDrawerReducers";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import SelectAll from "../Components/SelectAll";
import { current } from "@reduxjs/toolkit";
import BreadCrumb from "../Components/BreadCrumb";
import BackButton from "../../BackButton/BackButton";
import FileBulkActionBar from "../Components/Mobile/FileBulkActionBar";
import Filelist from "../Components/Mobile/Filelist";

const Favourites = () => {
  const [openFilter, setOpenFilter] = useState(false);
  // const [favFiles, setFavFiles] = useState(null);
  // const [loading, setLoading] = useState(false);
  const [activeView, setActiveView] = useState("file");
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [currentFolder, setCurrentFolder] = useState(null);
  const [path, setPath] = useState([]);

  const { modal, reqData, openModal, closeModal } = useModal();
  const { token } = useAuth();
  const {
    favourite,
    download,
    openRename,
    openDelete,
    openMove,
    preview,
    deleteFile,
    folderDownload,
    isDeleting,
    isFavouriting,
  } = useFileActions({ token, openModal, closeModal });
  const dispatch = useDispatch();
  const chatDrawerState = useSelector((state) => state?.ChatDrawerState);

  const query = !currentFolder
    ? {
        token,
        endpoint: "repoview/",
        queryKey: "favourites",
        view: "favourites",
        page: currentPage,
        search,
        filters,
      }
    : {
        token,
        endpoint: "manual-upload/folder-contents/",
        queryKey: "folderContents",
        folderId: currentFolder?.id,
        page: currentPage,
        search,
        filters,
      };

  const { data, isLoading, isFetching } = useRepoQuery(query);

  const favFiles = data;

  const handleFilterClick = () => {
    setOpenFilter(true);
  };

  const closeFilterDrawer = () => {
    setOpenFilter(false);
  };

  function onPageChange(page) {
    setCurrentPage(page);
  }

  const handlers = {
    favourite,
    openRename,
    openDelete,
    openMove,
    download,
    folderDownload,
  };

  const folderClick = (clickedFolder) => {
    const newPath = { id: clickedFolder?.id, name: clickedFolder?.folder_name };
    setCurrentPage(1);
    setPath((prev) => [...prev, newPath]);
    setCurrentFolder(newPath);
    logAccess(token, "folder", clickedFolder?.id);
  };

  const handleSearchChange = useCallback(
    (input) => {
      if (input === search) return;
      setSearch(input);
      setCurrentPage(1);
    },
    [search],
  );

  const columns = [
    {
      key: "s3_url",
      title: "Name",
      sortable: true,
      sortAccessor: (row) =>
        row?.item_type === "folder" ? row?.folder_name : row?.file_name,
      render: (val, row, idx) => {
        const FileIcon = fileIcons?.[row?.file_type] || fileIcons?.["folder"];
        return (
          <button
            // onClick={() => folderClick(row)}
            className="border-none bg-transparent flex items-center gap-2 w-full"
          >
            <span>{FileIcon && <FileIcon />}</span>
            <span className="truncate text-[#555555] font-normal text-[0.8rem]">
              {row?.item_type === "folder" ? row?.folder_name : row?.file_name}
            </span>
          </button>
        );
      },
    },
    {
      key: "upload_type",
      title: "",
      render: (val, row) => (
        <div className="file-type">
          {val ? val : row?.item_type === "folder" ? "Generated" : ""}
        </div>
      ),
    },
    {
      key: "full_path",
      title: "Location",
      align: "left",
      render: (val) => (
        <div className="truncate text-[#555555] font-normal text-[0.8rem]">
          {val.replace(/^Manually uploaded\//i, "")}
        </div>
      ),
    },
    {
      key: "updated_at",
      title: "Updated On",
      align: "left",
      sortable: true,
      type: "date",
      render: (val) => (
        <div className="truncate text-[#555555] font-normal text-[0.8rem]">
          {format(new Date(val), "dd/MM/yy")}
        </div>
      ),
    },
    {
      key: "file_size",
      title: "Size",
      type: "number",
      sortable: true,
      align: "left",
      render: (val, row, idx) => (
        <span className="truncate text-[#555555] font-normal text-[0.8rem]">
          {formatFileSize(row?.["file_size"])}
        </span>
      ),
    },
    {
      key: "original_name",
      title: "",
      align: "left",
      render: (val, row, idx, isHovered) => {
        let rowActions = getFileActions({ row, handlers });
        return (
          <div
            style={{
              position: "relative",
              overflow: "visible",
              width: 5 * 28 + 10,
              minWidth: 5 * 28 + 10,
              // width:'100%',
              padding: "0 8px",
            }}
          >
            <RowActionsTray
              actions={rowActions}
              row={row}
              visible={isHovered}
            />
          </div>
        );
      },
    },
  ];

  const handleApplyFilter = (filterObj) => {
    setFilters(filterObj);
    setCurrentPage(1);
    closeFilterDrawer();
  };
  const resetFilter = () => {
    setFilters(null);
    setCurrentPage(1);
    closeFilterDrawer();
  };

  function handleBreadCrumClick(folder, index) {
    const newPath = path.slice(0, index + 1);
    setPath(newPath);
    setCurrentFolder(folder);
  }

  const selectableRows =
    favFiles?.all?.filter((row) => row?.upload_type === "Manual") || [];

  function goBackOneFolder() {
    if (path.length <= 1) {
      setCurrentFolder(null);
      setPath([]);
    } // Already at root, cannot go back

    // Get new path by removing the last folder
    const newPath = path.slice(0, path.length - 1);

    // Update current folder to the new last folder in path
    const newCurrentFolder = newPath[newPath.length - 1] || null;

    setPath(newPath);
    setCurrentFolder(newCurrentFolder);
  }

  return (
    <>
      <Header
        searchParam={search}
        setSearchParam={handleSearchChange}
        activeView={activeView}
        setActiveView={setActiveView}
        clickFilter={handleFilterClick}
        title={"Favourites"}
        btnLabel={null}
        fileView={true}
        isFilter={true}
        searchPlaceholder="Search files or folders"
        justify={window.innerWidth < 650 ? 'justify-end' : null}
      />
      <Filter
        open={openFilter}
        close={closeFilterDrawer}
        updatedOn={true}
        fileType={true}
        appliedFilters={filters}
        applyFilter={handleApplyFilter}
        enableResults={true}
        filterAPI="repoview/"
        view={"favourites"}
        onReset={resetFilter}
      />
      <div className="md:shadow-[0_0_12px_#00000014] px-2 md:px-8 py-2 bg-white rounded-[12px] mt-4">
        {isLoading || isFavouriting || isFetching ? (
          <Loader />
        ) : (
          <>
            {Array.isArray(path) && path?.length > 0 && (
              <div className="mt-2">
                <BackButton
                  marginBottom="0"
                  buttonName={"Back"}
                  onClick={goBackOneFolder}
                />

                <BreadCrumb path={path} onFolderClick={handleBreadCrumClick} />
              </div>
            )}
            {activeView === "file" ? (
              <>
                {window.innerWidth < 640 ? (
                  <div className="flex flex-col gap-4">
                    {selectedKeys?.length > 0 && (
                      <FileBulkActionBar
                        data={favFiles?.all}
                        handleDelete={openDelete}
                        selectedKeys={selectedKeys}
                        setSelectedKeys={setSelectedKeys}
                        handleFav={favourite}
                      />
                    )}
                    <Filelist
                      data={favFiles?.all}
                      folderClick={folderClick}
                      filePreview={preview}
                      handleMove={openMove}
                      handleRename={openRename}
                      handleDelete={openDelete}
                      currentFolder={currentFolder}
                      changeFav={favourite}
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      isFav={true}
                    />
                  </div>
                ) : (
                  <>
                    <SelectAll
                      selectableRows={selectableRows}
                      handleRemoveFav={favourite}
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      handleDelete={openDelete}
                    />
                    <DataTable
                      columns={columns}
                      maxHeight="max-h-90vh"
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      checkable={true}
                      rowSelectable={(row) =>
                        row?.upload_type === "Manual" || false
                      }
                      dataSource={favFiles?.all}
                      rowKey="key"
                      emptyText="No favourite files found"
                      onRow={(row) => ({
                        onClick: () => {
                          if (row?.item_type === "folder") {
                            folderClick?.(row);
                          } else {
                            preview(row);
                          }
                        },
                      })}
                    />
                  </>
                )}
              </>
            ) : (
              <GridView
                handleMove={openMove}
                handleRename={openRename}
                changeFav={favourite}
                files={favFiles?.files}
                previewFile={preview}
                handleDelete={openDelete}
                folders={favFiles?.folders}
                totalFiles={favFiles?.totalFiles}
                totalFolders={favFiles?.totalFolders}
                folderClickFromView={folderClick}
                setSelectedKeys={setSelectedKeys}
                selectedKeys={selectedKeys}
              />
            )}
          </>
        )}
      </div>
      <div className="my-2">
        <Pagination
          currentPage={currentPage}
          onPageChange={onPageChange}
          totalCount={favFiles?.count || 12}
        />
      </div>
      <RenameModal
        open={modal === "rename"}
        close={closeModal}
        file={reqData}
      />
      <DeleteModal
        open={modal === "delete"}
        close={closeModal}
        handleDelete={() =>
          deleteFile(
            reqData || selectedKeys,
            "soft",
            selectedKeys?.length > 0 ? setSelectedKeys : null,
          )
        }
        fileName={reqData?.file_name || null}
        selectedKeys={selectedKeys}
        loading={isDeleting}
      />
      <FilePreviewModal2
        isOpen={modal === "filePreview" ? true : false}
        file={reqData}
        onClose={closeModal}
      />
      <MoveFile
        open={modal === "moveFile" ? true : false}
        file={reqData}
        close={closeModal}
        // afterSubmit={getData}
      />
      <FloatingAIButton
        onClick={() => {
          dispatch(setDrawerState(!chatDrawerState.isOpen));
          dispatch(setIsWebAllowed(true));
          dispatch(setQueryMetaData(null));
        }}
      />
    </>
  );
};

export default Favourites;
